import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "結案",
    isNumber: true,
  },
];

export const HealthCenterYearAndMonthClosedCount = {
  label: "每年/每月結案人數(衛生所)",
  key: "HealthCenterYearAndMonthClosedCount",
  path: "HealthCenterHealthCheckup/HealthCenterYearAndMonthClosedCount",
  api: "TCS_V_HCCS02",
  render: (options) => (
    <Diagram.HealthCenterHealthCheckup.HealthCenterYearAndMonthClosedCount
      {...options}
    />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "衛生所",
      field: "衛生所",
      header: "衛生所",
    },
  ],
  filterColumns: [
    { key: "填表次序", type: "string" },
    { key: "性別", type: "string" },
    { key: "教育程度", type: "string" },
    { key: "縣市", type: "string" },
    { key: "鄉鎮", type: "string" },
    { key: "衛生所", type: "string" },
  ],
  levelColumns,
  columns: [],
};
